var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('div',{attrs:{"id":"reportViewer1"}},[_vm._v("loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }